import { render, staticRenderFns } from "./StartupDetails.vue?vue&type=template&id=4071e8f1&scoped=true&"
import script from "./StartupDetails.vue?vue&type=script&lang=js&"
export * from "./StartupDetails.vue?vue&type=script&lang=js&"
import style0 from "./StartupDetails.vue?vue&type=style&index=0&id=4071e8f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4071e8f1",
  null
  
)

export default component.exports